import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Form, Input, Image } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { loginAPI } from '../apis';
import StoreManager from '../appdata';
import resource from '../resource';

class LoginScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
        StoreManager.rootState.thisLogin = this;
    }

    onFinished = async (form) => {
        this.setState({ isLoading: true });
        loginAPI(form.username, form.password);
    }

    render() {
        const { isLoading } = this.state;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Image width={200} src={resource.images.logo} preview={false} />

                {/* <p style={{ fontSize: 25, fontWeight: '500' }}>Trường Uy Admin</p> */}
                <Form
                    name="normal_login"
                    className="login-form"
                    onFinish={this.onFinished}
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your Username!' }]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Password"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button loading={isLoading} style={{ width: 300 }} type="primary" htmlType="submit" className="login-form-button">
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

export default withTranslation()(LoginScreen);
